<template>
<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" :class="[`${prefix}-icon`, `${prefix}-icon-YiMaoJian`]" width="1em" height="1em" v-bind="$attrs"><path d="M20.7649 15.2226H3.23512C3.10527 15.2226 3 15.1173 3 14.9875 3 11.7411 5.63171 9.10938 8.87805 9.10938H15.1219C18.3683 9.10938 21 11.7411 21 14.9875 21 15.1173 20.8947 15.2226 20.7649 15.2226zM9.83984 5.37736C9.83984 4.69811 9.98384 3 11.9998 3 13.7998 3 14.1598 4.35849 14.1598 4.69811 14.1598 4.99004 14.0529 6.2857 12.743 6.64385 12.3434 6.75309 11.9998 7.07164 11.9998 7.48585V8.77357" stroke="#333" stroke-linecap="round"/><path d="M15.1803 11.7969H8.82031C7.78478 11.7969 6.94531 12.6363 6.94531 13.6719V19.5021C6.94531 20.5376 7.78478 21.3771 8.82031 21.3771H15.1803C16.2158 21.3771 17.0553 20.5376 17.0553 19.5021V13.6719C17.0553 12.6363 16.2158 11.7969 15.1803 11.7969Z" stroke="#333"/></svg>
</template>
<script>

export default {
  name: 'IconYiMaoJian',
  props: {
    prefix: {
        type: String,
        default: 'LAIDO',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
